import { authHeader } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8003';

// Crear una nueva campaña (solo contenedor, sin PDF)
export async function crearCampania(data) {
  const response = await fetch(`${API_URL}/api/v1/campanias/crear`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json();
    let mensaje = error.detail || 'Error al crear la campaña';
    
    // Manejo específico para errores de créditos
    if (response.status === 402) {
      mensaje = 'No tienes créditos disponibles. Actualiza tu plan para continuar.';
    }
    
    throw new Error(mensaje);
  }

  return response.json();
}

// Subir y procesar un PDF asociado a una campaña
export async function subirPDFCampania(campaniaId, archivo) {
  const formData = new FormData();
  formData.append('archivo', archivo);

  const response = await fetch(`${API_URL}/api/v1/campanias/${campaniaId}/subir-pdf`, {
    method: 'POST',
    headers: authHeader(), // No incluir 'Content-Type' porque FormData lo establece automáticamente
    body: formData,
  });

  if (!response.ok) {
    const error = await response.json();
    let mensaje = error.detail || 'Error al subir el PDF';
    
    // Manejo específico para errores de limitaciones
    if (response.status === 400) {
      // Errores de validación (más de 10 páginas, límite de 50 PDFs, etc.)
      mensaje = error.detail || 'Error de validación al subir el PDF';
    } else if (response.status === 402) {
      mensaje = 'No tienes créditos disponibles. Actualiza tu plan para continuar.';
    } else if (response.status === 429) {
      // 🔥 ACTUALIZADO: límite de 50 procesamientos diarios
      mensaje = 'Has alcanzado el límite de 50 procesamientos de PDF en el día. Vuelve mañana.';
    }
    
    throw new Error(mensaje);
  }

  return response.json();
}

// Listar todas las campañas del usuario autenticado
export async function listarCampanias(skip = 0, limit = 50) {
  const response = await fetch(`${API_URL}/api/v1/campanias/?skip=${skip}&limit=${limit}`, {
    method: 'GET',
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al listar las campañas');
  }

  return response.json();
}

// Obtener una campaña específica por ID
export async function obtenerCampania(campaniaId) {
  const response = await fetch(`${API_URL}/api/v1/campanias/${campaniaId}`, {
    method: 'GET',
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al obtener la campaña');
  }

  return response.json();
}

// Actualizar una campaña (nombre, preferencias, etc.)
export async function actualizarCampania(campaniaId, data) {
  const response = await fetch(`${API_URL}/api/v1/campanias/${campaniaId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al actualizar la campaña');
  }

  return response.json();
}

// Eliminar una campaña
export async function eliminarCampania(campaniaId) {
  const response = await fetch(`${API_URL}/api/v1/campanias/${campaniaId}`, {
    method: 'DELETE',
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al eliminar la campaña');
  }

  return true;
}